import { z } from 'zod';
import { internationalPhoneSchema } from '../lib/validation';

export const branchSchema = z.object({
  Branch: z
    .string()
    .min(3, 'Branch Name must be at least 3 characters and up to 100 alphanumeric characters.')
    .max(100, 'Branch Name must be at least 3 characters and up to 100 alphanumeric characters.')
    .regex(/^[A-Za-z0-9 ]+$/, 'Branch Name must be at least 3 characters and up to 100 alphanumeric characters.'),
  // O3 (SO-24) — optional Arabic branch name shown to Arabic customers. Any script allowed.
  BranchNameAr: z
    .string()
    .max(100, 'Arabic branch name cannot exceed 100 characters.')
    .refine((v) => v.length === 0 || v.trim().length > 0, 'Invalid entry. Please check your input.')
    .optional(),
  StreetAddress: z
    .string()
    .min(5, 'Street address must be at least 5 characters.')
    .max(200, 'Street address cannot exceed 200 characters.')
    .regex(/^[A-Za-z0-9 \-#.,/'"]+$/, 'Invalid entry. Please check your input.'),
  City: z
    .string()
    .min(2, 'City is required')
    .max(100, 'City cannot exceed 100 characters.')
    .regex(/^[A-Za-z \-']+$/, 'Invalid entry. Please check your input.'),
  // State is optional (CR 2026-05-10): not all addresses have a meaningful
  // state/governorate (single-state countries, microstates, free-zone
  // addresses, etc.). When supplied, still enforce the same shape rules.
  State: z
    .union([
      z
        .string()
        .max(100, 'State cannot exceed 100 characters.')
        .regex(/^[A-Za-z \-']*$/, 'Invalid entry. Please check your input.'),
      z.literal(''),
    ])
    .optional(),
  Country: z
    .string()
    .min(2, 'Country is required')
    .max(100, 'Country cannot exceed 100 characters.')
    .regex(/^[A-Za-z \-']+$/, 'Invalid entry. Please check your input.'),
  PhoneNumber: internationalPhoneSchema,
  Status: z.boolean(),
  Headquarters: z.boolean(),
  Description: z.string().optional(),
  Latitude: z.number().optional(),
  Longitude: z.number().optional(),
});

export type BranchForm = z.infer<typeof branchSchema>;
